import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ResultDisplay from 'components/resultDisplay/ResultDisplay';
import passwordSuccessIcon from 'assets/images/password_success.png';
import './PasswordUpdateSuccess.scss';
import { buildLoginPath } from 'utils/pathBuilder';
import { useAutoNavigate } from 'hooks/useAutoNavigate';
import { useSession } from 'context/SessionContext';

type PasswordUpdateSuccessProps = {
  type: 'create' | 'reset'| 'change';
};

const PasswordUpdateSuccess: React.FC<PasswordUpdateSuccessProps> = ({type,}) => {
  const { t } = useTranslation('password_update_success');
  const navigate = useNavigate();
  const { clearSession } = useSession();

  const targetPath = buildLoginPath();

  React.useEffect(() => {
    clearSession();
  }, [ clearSession]);

  useAutoNavigate(targetPath);

  const handleDone = () => {
    navigate(targetPath);
  };

  return (
    <ResultDisplay
      title={type === 'create' ? t('createTitle') : (type === 'change' ? t('changeTitle') : t('title'))}
      imageUrl={passwordSuccessIcon}
      onNext={handleDone}
      nextText={t('gotoLoginPage')}
      showFooter={true}
    >
      <div className="password-update-success-message">
        <div>{type === 'create' ? t('createMessage') : (type === 'change' ? t('changeMessage') : t('message'))}</div>
      </div>
    </ResultDisplay>
  );
};

export default PasswordUpdateSuccess;
